//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Framingham',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
        item8: '0',
        item9: '0',
      },
      form1: {
        item10: '0',
        item11: '0',
        item12: '0',
        item13: '0',
        item14: '0',
        item15: '0',
        item16: '0',
      },
      hasScore: false,
      disabled: false,
      textFlag: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let form1 = JSON.parse(JSON.stringify(self.form1))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      for (const key in form1) {
        if (form.hasOwnProperty(key)) {
          if (!form1[key]) {
            flag = false
          } else {
            form1[key] = Number(form1[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        let result
        let num = 0
        let num1 = 0
        for (let key in form) {
          if (form[key] == 1) {
            num++
          }
        }
        for (let i in form1) {
          if (form1[i] == 1) {
            num1++
          }
        }
        console.log('num', num, 'num1', num1);
        if (num >= 2) {
          self.textFlag = true
        } else if (num == 1 && num1 >= 2) {
          self.textFlag = true
        } else {
          self.textFlag = false
        }
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Framingham.vue